import LanguageModal from "./LanguageModal";
import HomeInfoModal from  "./HomeInfoModal";
import AllergenListModal from "./AllergenListModal";
import ProductDetailModal from "./ProductDetailModal";
import BasketModal from "./BasketModal";
import CookiePreferencesModal from "./CookiePreferencesModal";
import WiFiModal from "./WiFiModal";

const modals = [
    {
        name: 'italian_language',
        element: LanguageModal
    },
    {
        name: 'italian_home_info',
        element: HomeInfoModal
    },
    {
        name: 'italian_allergen_list',
        element: AllergenListModal
    },
    {
        name: 'italian_product_detail',
        element: ProductDetailModal
    },
    {
        name: 'italian_basket',
        element: BasketModal
    },
    {
        name: 'italian_cookie_preferences',
        element: CookiePreferencesModal
    },
    {
        name: 'italian_wifi_modal',
        element: WiFiModal
    }
];

export default modals;